import { CreateSavedTicketHoldersRequest } from '@core/features/account/features/saved-ticket-holders/models/saved-ticket-holders-api.model';
import { createActionGroup, emptyProps } from '@ngrx/store';

export const PrepareOrderActions = createActionGroup({
  source: 'Prepare Order',
  events: {
    'Prepare and send order': emptyProps(),
    'Prepare anonymous ticket order': emptyProps(),
    'Create ticket holder persons before save order': (
      createSavedTicketHoldersRequest: CreateSavedTicketHoldersRequest
    ) => ({ createSavedTicketHoldersRequest }),
    'Skip create ticket holder persons before save order': emptyProps()
  }
});
